// Gruppi Django che accedono alle pagine della sezione Console.
// La sezione è visibile alla somma dei gruppi delle sue schede; ogni scheda solo a chi può usarla.
export const consoleGroups = ["Amministrazione", "Console", "Milkrun", "Tecnici", "Tempi&Metodi", "Qualità"];
export const logsGroups = [...consoleGroups, "Logs"];
export const consoleSectionGroups = Array.from(new Set([...consoleGroups, ...logsGroups]));
